import api from "../api";
import business_id from "../business"
import { toast } from 'vue3-toastify'

export default {
  namespaced: true,
  state: {
    product: {},
    products: [],
    paginate: {},
    tcg_products: [],
    tcg_paginate: {},
    acs_products: [],
    acs_paginate: {},
    filter_products: {},
    api_products: {},
    api_products_bra: {},
    api_products_tcg: {},
    api_categories_tcg: {},
    store: {},
    rank_cards_low: [],
    cards_low_paginate: {},
    rank_cards_high: [],
    cards_high_paginate: {},
    rank_cards_views: [],
    cards_views_paginate: {},
    rank_cards_order_count: [],
    cards_order_count_paginate: {},

    after_initial_rank: [],
    after_initial_rank_paginate: {},
    initial_rank: [],
    initial_rank_paginate: {},
    stats_price: {},
    conditions: {},
    product_history_order: [],
    product_history_order_condition: {},

    product_bra_stores: [],
    product_tcg_stores: [],
    product_card_stores: [],
    product_tcg_stores_paginate: {},
    product_bra_stores_paginate: {},
    product_card_stores_paginate: {},

    bra_data: {},
    free_shipping_day: {},

    tags: {},
  },
  getters: {

  },
  actions: {
    async get_products({ dispatch, commit }, payload = []) {
      try {

        //frete gratis
        let address = JSON.parse(sessionStorage.getItem("zipcodedefault"))?.uf || false
        payload.uf = address

        api.post(`/v1/${business_id}/products/paginate`, payload)
          .then((res) => {
           
            if (payload?.type == "after_initial_rank") { //rank list
              commit("LIST_AFTER_INITIAL_RANK_PRODUCTS", res?.data);
              return
            }
            if (payload?.type == "tcg") { // produto tcg
              commit("LIST_TCG_PRODUCTS", res?.data);
              return
            }
            if (payload?.type == "acs") { // acessorios
              commit("LIST_ACS_PRODUCTS", res?.data);
              return
            }
            if (payload?.type == "filter") {
              commit("LIST_FILTER_PRODUCTS", res?.data);
              return
            }
            
            commit("LIST_PRODUCTS", res?.data);
          })
          .catch((error) => {
            commit("ERROR_PRODUCTS", "Algo deu errado, entre em contato com os desenvolvedores");
          })
          .finally(() => (
            // this.loading = false
            console.log('')
          ));
      } catch (e) {
        commit("ERROR_PRODUCTS", "Algo deu errado, entre em contato com os desenvolvedores");
      }
    },
    async get_product({ commit }, obj) {
      try {

        let id = obj?.id || obj
        // //frete gratis
        // let address = JSON.parse(sessionStorage.getItem("zipcodedefault"))?.uf || false
        let payload = {}
        // payload.uf = address
        payload.filter = obj

        api.post(`/v1/${business_id}/products-show/${id}`, payload)
          .then((res) => {
            commit("SHOW_PRODUCT", res?.data);
          })
          .catch((error) => {
            commit("ERROR_PRODUCTS", "Algo deu errado, entre em contato com os desenvolvedores");
          })
          .finally(() => (
            // this.loading = false
            console.log('')
          ));
      } catch (e) {
        commit("ERROR_PRODUCTS", "Algo deu errado, entre em contato com os desenvolvedores"+e);
      }
    },

    async get_stores_by_product({ commit }, obj) {
      try {
        //frete gratis
        let address = JSON.parse(sessionStorage.getItem("zipcodedefault"))?.uf || false
        let payload = {}
        payload = obj
        payload.uf = address
        

        api.post(`/v1/${business_id}/product-stores/`, payload)
          .then((res) => {
            commit("LIST_STORES_BY_PRODUCT", res?.data);
          })
          .catch((error) => {
            commit("ERROR_PRODUCTS", "Algo deu errado, entre em contato com os desenvolvedores");
          })
          .finally(() => (
            // this.loading = false
            console.log('')
          ));
      } catch (e) {
        commit("ERROR_PRODUCTS", "Algo deu errado, entre em contato com os desenvolvedores"+e);
      }
    },

    async get_rank_cards({ commit }, payload = []) {
      try {

        await api.post(`/v1/${business_id}/HighAndLowCards`, payload)
          .then((res) => {

            if (payload.type == "product_stats.price_low") { // acessorios
              commit("LIST_CARDS_LOW", res?.data);
              return 1
            }
            if (payload.type == "product_stats.price_high") {
              commit("LIST_CARDS_HIGH", res?.data);
              return 1
            }

            if (payload.type == "product_views_summaries.monthly_views") {
              commit("LIST_CARDS_VIEWS", res?.data);
              return 1
            }

            if (payload.type == "product_sales_stats.monthly_sales") {
              commit("LIST_CARDS_ORDER_COUNT", res?.data);
              return 1
            }
          })
          .catch((error) => {
            commit("ERROR_PRODUCTS", "Algo deu errado, entre em contato com os desenvolvedores");
          })
          .finally(() => (
            // this.loading = false
            console.log('')
          ));
      } catch (e) {
        commit("ERROR_PRODUCTS", "Algo deu errado, entre em contato com os desenvolvedores"+e);
      }
    },

    async get_stats_price({ commit }, payload) {
      try {

        // var obj = {
        //   labels: [
        //     "Jan / Fev",
        //     "2º Bimestre",
        //     "3º Bimestre",
        //     "4º Bimestre",
        //     "5º Bimestre",
        //     "6º Bimestre",
        //   ],
        //   datasets: [
        //     {
        //       label: "Anual",
        //       data: [40.5, 70, 30, 40, 80, 20.53],
        //       borderColor: "#999999",
        //       backgroundColor: "#ff0000",
        //     },
        //   ],
        // };

        api.post(`/v1/${business_id}/product-stats-price`, payload)
          .then((res) => {
            commit("SET_STATS_PRICE", res?.data);
          })
          .catch((error) => {
            commit("ERROR_PRODUCTS", "Algo deu errado, entre em contato com os desenvolvedores");
          })
          .finally(() => (
            // this.loading = false
            console.log('')
          ));
      } catch (e) {
        commit("ERROR_PRODUCTS", "Algo deu errado, entre em contato com os desenvolvedores"+e);
      }
    },

    async create_product({ dispatch, commit }, payload = []) {
      try {
        api.post("/v1/product/create_product", payload)
          .then((res) => {
            if(res?.data?.error){
              console.log(res?.data?.error)
              //dispatch("alert/set_alert", {alert_message: "Erro ao salvar, aguarde e tente mais tarde", type_message: 'alert-danger'}, { root: true });

              //if (window.innerWidth < 480) {
                toast.warning("Erro ao salvar, aguarde e tente mais tarde", {
                  type: 'default',
                  theme: 'colored',
                  hideProgressBar: true,
                  dangerouslyHTMLString: true
                });
              //}

            }else{
              if(res?.data.card){
                //dispatch("alert/set_alert", {alert_message: "Salvo com sucesso: assim que sua sugestão for aprovada, você será notificado", type_message: 'alert-success'}, { root: true });
              
                toast.success("Salvo com sucesso: assim que sua sugestão for aprovada, você será notificado", {
                  type: 'default',
                  theme: 'colored',
                  hideProgressBar: true,
                  dangerouslyHTMLString: true
                });
              }
            }
          })
          .catch((error) => {
            //dispatch("alert/set_alert", {alert_message: "Erro ao salvar, aguarde e tente mais tarde", type_message: 'alert-danger'}, { root: true });

            toast.warning("Erro ao salvar, aguarde e tente mais tarde", {
              type: 'default',
              theme: 'colored',
              hideProgressBar: true,
              dangerouslyHTMLString: true
            });

            commit("ERROR_ADD_PRODUCT", "Erro ao carregar");
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_ADD_PRODUCT", e);
      }
    },

    async get_items_by_api({ commit }, payload = null) {
      try {
        let product_name = payload?.query || payload
        api.get(`/v1/${business_id}/products-by-api?query=${product_name || ''}&collection_code=${payload?.category || ''}&can_send_bra_center=${payload?.can_send_bra_center || ''}`)
          .then((res) => {
            commit("SET_API_PRODUCTS", res?.data);

          })
          .catch((error) => {
            commit("ERROR_PRODUCTS", "Algo deu errado, entre em contato com os desenvolvedores");
          })
          .finally(() => (
            // this.loading = false
            console.log('')
          ));
      } catch (e) {
        commit("ERROR_PRODUCTS", "Algo deu errado, entre em contato com os desenvolvedores"+e);
      }
    },

    async get_items_by_api_bra({ commit }, product_name) {
      try {

        api.get(`/v1/${business_id}/products-by-api-bra/${product_name}`)
          .then((res) => {
            commit("SET_API_PRODUCTS_BRA", res?.data);

          })
          .catch((error) => {
            commit("ERROR_PRODUCTS", "Algo deu errado, entre em contato com os desenvolvedores");
          })
          .finally(() => (
            // this.loading = false
            console.log('')
          ));
      } catch (e) {
        commit("ERROR_PRODUCTS", "Algo deu errado, entre em contato com os desenvolvedores"+e);
      }
    },

    async find_by_rdc({ commit }, rdc) {
      try {

        api.get(`/v1/${business_id}/find-by-rdc/${rdc}`)
          .then((res) => {
            commit("SET_API_PRODUCTS_BRA", res?.data);

          })
          .catch((error) => {
            commit("ERROR_PRODUCTS", "Algo deu errado, entre em contato com os desenvolvedores");
          })
          .finally(() => (
            // this.loading = false
            console.log('')
          ));
      } catch (e) {
        commit("ERROR_PRODUCTS", "Algo deu errado, entre em contato com os desenvolvedores"+e);
      }
    },

    async get_items_by_api_tcg({ commit }, payload = null) {
      try {
        let product_name = payload?.query || ""
        api.get(`/v1/${business_id}/products-by-api-tcg?query=${product_name || ''}&category=${payload?.category || ''}`)
          .then((res) => {
            commit("SET_API_PRODUCTS_TCG", res?.data);

          })
          .catch((error) => {
            commit("ERROR_PRODUCTS", "Algo deu errado, entre em contato com os desenvolvedores");
          })
          .finally(() => (
            // this.loading = false
            console.log('')
          ));
      } catch (e) {
        commit("ERROR_PRODUCTS", "Algo deu errado, entre em contato com os desenvolvedores"+e);
      }
    },

    async get_categories_tcg({ commit }) {
      try {

        api.get(`/v1/${business_id}/get-categories-tcg`)
          .then((res) => {
            commit("SET_CATEGORIES_TCG", res?.data);

          })
          .catch((error) => {
            commit("ERROR_PRODUCTS", "Algo deu errado, entre em contato com os desenvolvedores");
          })
          .finally(() => (
            // this.loading = false
            console.log('')
          ));
      } catch (e) {
        commit("ERROR_PRODUCTS", "Algo deu errado, entre em contato com os desenvolvedores"+e);
      }
    },

    


    
    async get_conditions_by_product_id({ commit }, payload) {
      try {

        api.post(`/v1/${business_id}/conditions-by-product-id`, payload)
          .then((res) => {
            commit("SET_CONDITIONS", res?.data);
          })
          .catch((error) => {
            commit("ERROR_PRODUCTS", "Algo deu errado, entre em contato com os desenvolvedores");
          })
          .finally(() => (
            // this.loading = false
            console.log('')
          ));
      } catch (e) {
        commit("ERROR_PRODUCTS", "Algo deu errado, entre em contato com os desenvolvedores"+e);
      }
    },

    async get_product_history_order({ commit }, payload) {
      try {

        api.post(`/v1/${business_id}/product-history-order`, payload)
          .then((res) => {
            commit("SET_HISTORY_ORDER", res?.data);
          })
          .catch((error) => {
            commit("ERROR_PRODUCTS", "Algo deu errado, entre em contato com os desenvolvedores");
          })
          .finally(() => (
            // this.loading = false
            console.log('')
          ));
      } catch (e) {
        commit("ERROR_PRODUCTS", "Algo deu errado, entre em contato com os desenvolvedores"+e);
      }
    },

    async get_product_bra_data({ commit }, payload) {
      try {

        api.post(`/v1/${business_id}/product-bra-data`, payload)
          .then((res) => {
            commit("SET_BRA_DATA", res?.data);
          })
          .catch((error) => {
            commit("ERROR_PRODUCTS", "Algo deu errado, entre em contato com os desenvolvedores");
          })
          .finally(() => (
            // this.loading = false
            console.log('')
          ));
      } catch (e) {
        commit("ERROR_PRODUCTS", "Algo deu errado, entre em contato com os desenvolvedores"+e);
      }
    },

    async get_free_shipping_day({ dispatch, commit }, payload) {
      try {
        const res = await api.post("/v1/free-shipping-day", payload);
          if (res?.data?.error) {
            commit("ERROR_FREE_SHIPPING_DAY", "Algo deu errado");
            commit("GET_FREE_SHIPPING_DAY", {})
            return { error: res.data.error };
          } else {
            commit("GET_FREE_SHIPPING_DAY", {
              result: res.data.result,
              dayOfWeek: res.data.dayOfWeek,
            });
           return { data: res?.data };
          }
        
        } catch (error) {
          console.log(error); 
          commit("GET_FREE_SHIPPING_DAY", {})
          return { error: error.message || error };
        } finally {
          console.log('Requisição finalizada');
        }
    },

    async get_tags({ commit }, used_in) {
      try {
        api.get(`/v1/tags?used_in=${used_in}`)
          .then((res) => {
            commit("GET_TAGS", res?.data);
          })
          .catch((error) => {
            commit("ERROR_TAGS", "Algo deu errado, entre em contato com os desenvolvedores");
          })
          .finally(() => (
            // this.loading = false
            console.log('')
          ));
      } catch (e) {
        commit("ERROR_TAGS", e);
      }
    },

  },
  mutations: {
    LIST_STORES_BY_PRODUCT(state, data){
      if(data?.product_type == "bra"){
        if (data?.paginate.current_page == 1) {
          state.product_bra_stores = data?.stores
        } else {
          state.product_bra_stores.push(...data?.stores)
        }
        state.product_bra_stores_paginate = data?.paginate
      }  
      if(data?.product_type == "card"){
        if (data?.paginate.current_page == 1) {
          state.product_card_stores = data?.stores
        } else {
          state.product_card_stores.push(...data?.stores)
        }
        state.product_card_stores_paginate = data?.paginate
      }  
      if(data?.product_type == "tcg"){
        if (data?.paginate.current_page == 1) {
          state.product_tcg_stores = data?.stores
        } else {
          state.product_tcg_stores.push(...data?.stores)
        }
        state.product_tcg_stores_paginate = data?.paginate
      }  
    },
    LIST_PRODUCTS(state, data) {
      if (data?.paginate.current_page == 1) {
        state.products = data?.products
      } else {
        state.products.push(...data?.products)
        // setTimeout(() => {
        //   document.getElementById("scroll").scrollTo(0,document.getElementById("scroll").scrollHeight)
        // }, "500");
      }
      state.paginate = data?.paginate
      state.store = data?.store
    },
    LIST_TCG_PRODUCTS(state, data) {
      if (data?.paginate.current_page == 1) {
        state.tcg_products = data?.products
      } else {
        state.tcg_products.push(...data?.products)
      }
      state.tcg_paginate = data?.paginate
    },
    LIST_ACS_PRODUCTS(state, data) {
      if (data?.paginate.current_page == 1) {
        state.acs_products = data?.products
      } else {
        state.acs_products.push(...data?.products)
      }
      state.acs_paginate = data?.paginate
    },
    LIST_FILTER_PRODUCTS(state, data) {
      var result = data?.products.map((m) => { return { 
        "name": m.name, 
        "number": m.card_number, 
        "code": m.id, 
        "collection": (m.collection?.length || 0) > 0 ? m.collection[0].name : null, 
        "codePro": m.code, 
        // "codeCat": (m.collection?.length || 0) > 0 ? m.collection[0].code : null, 
        // "series": (m.collection?.length || 0) > 0 ? m.collection[0].series : null, 
        // "total": (m.collection?.length || 0) > 0 ? m.collection[0].total : null, 
        // "date": (m.collection?.length || 0) > 0 ? m.collection[0].release_date : null, 
        "url": m?.product_image[0].image ?? null, 
        "price": m?.product_store_min?.price ?? m?.product_store_max?.price ?? null,
      } })
      if (data?.paginate.current_page == 1) {
        state.filter_products = result
      } else {
        state.filter_products.push(...result)
      }
      // state.acs_paginate = data?.paginate
    },
    SHOW_PRODUCT(state, data) {
      state.product = data
    },
    ERROR_PRODUCTS(state, data) {
      console.log(data)
    },
    LIST_CARDS_LOW(state, data) {
      if (data?.paginate.current_page == 1) {
        state.rank_cards_low = data?.products
      } else {
        state.rank_cards_low.push(...data?.products)
      }
      state.cards_low_paginate = data?.paginate
    },
    LIST_CARDS_HIGH(state, data) {
      if (data?.paginate.current_page == 1) {
        state.rank_cards_high = data?.products
      } else {
        state.rank_cards_high.push(...data?.products)
      }
      state.cards_high_paginate = data?.paginate
    },
    LIST_CARDS_VIEWS(state, data) {
      if (data?.paginate.current_page == 1) {
        state.rank_cards_views = data?.products
      } else {
        state.rank_cards_views.push(...data?.products)
      }
      state.cards_views_paginate = data?.paginate
    },
    LIST_CARDS_ORDER_COUNT(state, data) {
      if (data?.paginate.current_page == 1) {
        state.rank_cards_order_count = data?.products
      } else {
        state.rank_cards_order_count.push(...data?.products)
      }
      state.cards_order_count_paginate = data?.paginate
    },
    
    LIST_AFTER_INITIAL_RANK_PRODUCTS(state, data) {
      if (data?.paginate.current_page == 1) {
        state.after_initial_rank = data?.products
      } else {
        state.after_initial_rank.push(...data?.products)
      }
      state.after_initial_rank_paginate = data?.paginate
    },
    SET_STATS_PRICE(state, data){
      state.stats_price = data
    },
    SET_API_PRODUCTS(state, data){
      state.api_products = data
    },
    SET_API_PRODUCTS_BRA(state, data){
      state.api_products_bra = data
    },
    SET_API_PRODUCTS_TCG(state, data){
      state.api_products_tcg = data
    },
    
    SET_CATEGORIES_TCG(state, data){
      state.api_categories_tcg = data
    },
    SET_CONDITIONS(state, data){
      state.conditions = data
    },
    SET_HISTORY_ORDER(state, data){
      state.product_history_order = data
    },
    SET_HISTORY_ORDER_CONDITION(state, data){
      state.product_history_order_condition = data
    },
    SET_BRA_DATA(state, data){
      state.bra_data = data
    },

    GET_FREE_SHIPPING_DAY(state, data) {
      state.free_shipping_day = data
    },
    ERROR_FREE_SHIPPING_DAY(state, data) {
      console.log(data)
    },

    GET_TAGS(state, data) {
      state.tags = data
    },
    ERROR_TAGS(state, data) {
      console.log(data)
    },
  }
}




